var React = require('react');

var Input = require('./index.js');
var Row = require('../grid/row');
var Col = require('../grid/col');
var css = require('./module.scss');


var InputGroup = React.createClass({

    getInitialState: function() {
        return {
        };
    },


    componentDidUpdate: function() {},

    onChange: function(value) {
        this.props.onChange && this.props.onChange(value);
    },

    onMoreChange: function(value) {
        this.props.onMoreChange && this.props.onMoreChange(value);
    },

    render: function() {
        var _this = this;
        var phs = this.props.placeholder ? this.props.placeholder.split('|') : [];
        return (
            <Row className='fp-input-group'>
                <Col span={11}>
                    <Input
                        ref={this.props.name}
                        name={this.props.name}
                        value={this.props.value}
                        onChange={this.onChange.bind(this)}
                        placeholder={phs[0]}
                        size={this.props.size}
                        wtype={this.props.wtype}
                        dataType={this.props.dataType}
                    />
                </Col>
                {
                    this.props.more ? (
                        <Col span={2} className='fp-input-more-text'>—</Col>
                    ) : null
                }
                {
                    this.props.more ? (
                        <Col span={11}>
                            <Input
                                ref={this.props.more}
                                name={this.props.more}
                                value={this.props.moreValue}
                                onChange={this.onMoreChange.bind(this)}
                                placeholder={phs[1]}
                                size={this.props.size}
                                wtype={this.props.wtype}
                                dataType={this.props.moreDataType}
                            />
                        </Col>
                    ) : null
                }
            </Row>
        );
    }

});

module.exports = InputGroup;



// WEBPACK FOOTER //
// ./component/input/group.js